import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={17.788}
    height={26.074}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 13448 19712"
    {...props}
  >
    <path
      d="m5241 18052 2967-9c-104 1149-2812 1185-2967 9zm698-8204c-37-765 59-1327-327-1941-129-204-356-426-664-474-1632-256-1739 2265 479 2789l-5 4132-1293 3c34-1119-539-2295-1273-2973-276-254-453-434-704-736C1320 9645 708 8065 848 6325 1089 3333 3592 841 6724 841c3156 0 5618 2474 5876 5482 176 2039-704 3936-1992 5048-809 699-1270 1794-1289 2978l-1284 8 15-4166c164 2 608-248 768-332 700-364 1123-1187 821-1849-173-377-665-643-1113-579-317 44-550 260-676 462-406 647-294 1135-339 1935-594 129-989 95-1572 20zm1576 531v3966l-1579 12v-3975c343 63 1133 83 1579-3zm510-720c10-458-36-1778 695-1710 360 34 556 291 477 688-95 479-726 926-1172 1022zm-3891 7678 4-773c298-84 4561-48 5178-4l2 768c-130 36-4764 37-5184 9zm-370-2278 5919-8 3 793-5915 9-7-794zm1662-5401c-564-153-1647-994-1051-1554 235-221 657-292 893 258 178 416 141 817 158 1296zm4576 6806c486-384 556-1533 130-1913-164-146-159-221-108-660 53-459 221-904 436-1256 109-178 219-345 351-479 420-428 858-832 1205-1316 771-1074 1236-2357 1287-3767 182-4966-4891-8390-9322-6318-663 309-1465 874-1953 1399C1011 3249 97 4836 145 7017c21 972 268 1986 645 2748 192 386 403 756 631 1059l1204 1317c490 575 799 1336 822 2135-26 50-982 1385 2 2188-5 580-148 1346 481 1548 189 60 422 14 624 39 56 604 306 939 636 1194 561 435 2511 429 3070 2 332-254 580-590 637-1194 218-34 432 25 644-48 598-206 470-939 461-1541z"
      style={{
        fill: "#000",
        // stroke: "#2b2a29",
        strokeWidth: 285.737,
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
